import React from 'react';
import { DISTRIBUTOR_WHATSAPP_MESSAGE } from '../data/messages';
import { WhatsAppButton } from './WhatsAppButton';
export function DistributorSection() {
  return <section className="bg-steel-50 py-10 sm:py-16" data-id="element-21" data-mp="j45h7y428tg4">
      <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-22" data-mp="e5lsjpy313k2">
        <div className="flex flex-col gap-5 rounded-xl bg-navy-800 p-6 text-white sm:p-10 lg:flex-row lg:items-center lg:justify-between" data-id="element-23" data-mp="982f2s97kut6">
          <div className="max-w-2xl" data-id="element-24" data-mp="49isqqqpdh0a">
            <h2 className="font-display text-[1.75rem] font-bold leading-tight sm:text-4xl" data-id="element-25" data-mp="4ak4kxfjm7j2">
              ¿Casa de materiales o compras por volumen?
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-steel-200 sm:text-base" data-id="element-26" data-mp="3rmbc6g4xxx5h">
              Atendemos distribuidores, constructoras y compras recurrentes con condiciones especiales por volumen y
              zona. Tu margen también importa.
            </p>
          </div>
          <WhatsAppButton message={DISTRIBUTOR_WHATSAPP_MESSAGE} label="Pedir precio de distribuidor" location="distribuidores" intent="distribuidor" variant="white" size="lg" className="shrink-0" data-id="element-27" data-mp="3cpkag07so9cp" />
        </div>
      </div>
    </section>;
}